import styles from "./WhyChooseUs.module.css";
import Reveal from "./Reveal";
import Icon from "./Icons";
import Marquee from "./Marquee";
import { whyChooseUs } from "../data/content";

export default function WhyChooseUs({ headless = false }) {
  const H = headless ? "h2" : "h3";

  return (
    <section className={`u-section ${styles.section}`}>
      <div className="u-shell">
        {!headless && (
          <Reveal className={styles.head}>
            <p className="u-eyebrow">{whyChooseUs.eyebrow}</p>
            <h2 className={styles.heading}>{whyChooseUs.heading}</h2>
            <p className={styles.lead}>{whyChooseUs.lead}</p>
          </Reveal>
        )}

      </div>

      <Marquee speed={70} repeat={2} reverse ariaLabel="Our approach">
        {whyChooseUs.points.map((point) => (
          <div key={point.title} className={styles.point}>
            <span className={styles.icon}>
              <Icon name={point.icon} size={22} />
            </span>
            <H className={styles.title}>{point.title}</H>
            <p className={styles.text}>{point.text}</p>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
